import { FunctionComponent, useState } from 'react';
import { Autocomplete, Box, Button, Stack, TextField } from '@mui/material';
import { ConfigurationIdNameMap } from '@/models/textReplacement';

type AddProductPersonNameProps = {
    persons: ConfigurationIdNameMap[];
    products: ConfigurationIdNameMap[];
    onAddLine: (params: {
        person: ConfigurationIdNameMap;
        product: ConfigurationIdNameMap;
    }) => void;
};

export const AddProductPersonName: FunctionComponent<
    AddProductPersonNameProps
> = ({ persons, products, onAddLine }) => {
    const [selectedProduct, setSelectedProduct] =
        useState<ConfigurationIdNameMap>(null);
    const [selectedPerson, setSelectedPerson] =
        useState<ConfigurationIdNameMap>(null);
    return (
        <Box
            sx={{
                mt: 3,
                display: 'flex',
                alignItems: 'center',
                width: '100%',
            }}
        >
            <Stack
                sx={{
                    flexGrow: 1,
                    mr: 6,
                }}
                spacing={2}
                direction='row'
            >
                <Autocomplete
                    sx={{
                        width: '50%',
                        mx: 2,
                    }}
                    disablePortal
                    options={persons}
                    getOptionLabel={(option: ConfigurationIdNameMap) =>
                        option.name
                    }
                    onChange={(_, value) => {
                        setSelectedPerson(value as ConfigurationIdNameMap);
                    }}
                    renderInput={(params) => (
                        <TextField {...params} label='Personenbezeichnung' />
                    )}
                />

                <Autocomplete
                    sx={{
                        width: '50%',
                        mx: 2,
                    }}
                    disablePortal
                    options={products}
                    onChange={(_, value) => {
                        setSelectedProduct(value as ConfigurationIdNameMap);
                    }}
                    getOptionLabel={(option: ConfigurationIdNameMap) =>
                        option.name
                    }
                    renderInput={(params) => (
                        <TextField {...params} label='Ticketbezeichnung' />
                    )}
                />
            </Stack>

            <Button
                sx={{
                    width: 240,
                    ml: 'auto',
                }}
                variant='outlined'
                disabled={!selectedPerson || !selectedProduct}
                onClick={() =>
                    onAddLine({
                        person: selectedPerson,
                        product: selectedProduct,
                    })
                }
            >
                Kombination Hinzufügen
            </Button>
        </Box>
    );
};
